import { useEffect, useState } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';

// Compact editor for a per-user or per-ship-to billing address.
// Only meaningful once the parent record exists (refId set). Rendered by the
// user form (scope="user") and the ship-to form (scope="ship_to").
export default function BillingAddressEditor({ customerId, scope, refId, label }) {
  const empty = { name: '', address1: '', address2: '', city: '', state: '', zip: '', country: 'US', phone: '' };
  const [b, setB] = useState(empty);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!customerId || !refId) return;
    api.get(`/api/customers/${customerId}/billing/${scope}/${refId}`)
      .then(r => setB(r.data.billing ? { ...empty, ...r.data.billing } : empty))
      .catch(() => {});
  }, [customerId, scope, refId]);

  const set = (k, v) => setB(s => ({ ...s, [k]: v }));
  const save = async () => {
    setSaving(true);
    try { await api.put(`/api/customers/${customerId}/billing/${scope}/${refId}`, b); toast.success('Billing address saved'); }
    catch (e) { toast.error(e.response?.data?.error || 'Save failed'); }
    finally { setSaving(false); }
  };

  return (
    <div style={{ borderTop: '1px solid var(--gray-200)', marginTop: 10, paddingTop: 10 }}>
      <strong>{label || 'Billing address'}</strong>
      <p className="form-hint" style={{ marginTop: 2 }}>Used as the Bill To on work orders for this {scope === 'user' ? 'user' : 'ship-to'} (when the customer bills per {scope === 'user' ? 'user' : 'ship-to'}).</p>
      <div className="form-group"><label className="form-label">Bill to (company / attn)</label>
        <input className="form-input" value={b.name || ''} onChange={e => set('name', e.target.value)} /></div>
      <div className="form-row">
        <div className="form-group" style={{ flex: 2 }}><label className="form-label">Address 1</label>
          <input className="form-input" value={b.address1 || ''} onChange={e => set('address1', e.target.value)} /></div>
        <div className="form-group" style={{ flex: 1 }}><label className="form-label">Address 2</label>
          <input className="form-input" value={b.address2 || ''} onChange={e => set('address2', e.target.value)} /></div>
      </div>
      <div className="form-row">
        <div className="form-group" style={{ flex: 2 }}><label className="form-label">City</label>
          <input className="form-input" value={b.city || ''} onChange={e => set('city', e.target.value)} /></div>
        <div className="form-group" style={{ flex: 1 }}><label className="form-label">State</label>
          <input className="form-input" value={b.state || ''} onChange={e => set('state', e.target.value)} /></div>
        <div className="form-group" style={{ flex: 1 }}><label className="form-label">Zip</label>
          <input className="form-input" value={b.zip || ''} onChange={e => set('zip', e.target.value)} /></div>
      </div>
      <div className="form-row">
        <div className="form-group"><label className="form-label">Country</label>
          <input className="form-input" value={b.country || 'US'} onChange={e => set('country', e.target.value)} /></div>
        <div className="form-group"><label className="form-label">Billing phone</label>
          <input className="form-input" value={b.phone || ''} onChange={e => set('phone', e.target.value)} /></div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <button className="btn btn-secondary btn-sm" onClick={save} disabled={saving}>{saving ? 'Saving…' : 'Save billing address'}</button>
      </div>
    </div>
  );
}
